/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var rxjs_1 = require("rxjs");
var kendo_angular_l10n_1 = require("@progress/kendo-angular-l10n");
var utils_1 = require("../utils");
var column_base_1 = require("../columns/column-base");
var column_common_1 = require("../columns/column-common");
var kendo_angular_common_1 = require("@progress/kendo-angular-common");
var column_resizing_service_1 = require("./column-resizing.service");
var operators_1 = require("rxjs/operators");
var column_info_service_1 = require("../common/column-info.service");
// TODO
// tslint:disable:rxjs-no-unsafe-takeuntil
/**
 * @hidden
 */
var fromPercentage = function (value, percent) {
    var sign = percent < 0 ? -1 : 1;
    return Math.ceil((Math.abs(percent) / 100) * value) * sign;
};
var ɵ0 = fromPercentage;
exports.ɵ0 = ɵ0;
/**
 * @hidden
 */
var toPercentage = function (value, whole) { return (value / whole) * 100; };
var ɵ1 = toPercentage;
exports.ɵ1 = ɵ1;
/**
 * @hidden
 */
var headerWidth = function (handle) { return handle.nativeElement.parentElement.offsetWidth; };
var ɵ2 = headerWidth;
exports.ɵ2 = ɵ2;
/**
 * @hidden
 */
var allLeafColumns = function (columns) { return column_common_1.expandColumns(columns)
    .filter(function (c) { return !c.isColumnGroup; }); };
var ɵ3 = allLeafColumns;
exports.ɵ3 = ɵ3;
/**
 * @hidden
 */
var stopPropagation = function (_a) {
    var event = _a.originalEvent;
    event.stopPropagation();
    event.preventDefault();
};
var ɵ4 = stopPropagation;
exports.ɵ4 = ɵ4;
/**
 * @hidden
 */
var createMoveStream = function (service, draggable) { return function (mouseDown) {
    return draggable.kendoDrag.pipe(operators_1.takeUntil(draggable.kendoRelease.pipe(operators_1.tap(function () { return service.end(); }))), operators_1.map(function (_a) {
        var pageX = _a.pageX;
        return ({
            originalX: mouseDown.pageX,
            pageX: pageX
        });
    }));
}; };
var ɵ5 = createMoveStream;
exports.ɵ5 = ɵ5;
/**
 * @hidden
 */
var preventOnDblClick = function (release) { return function (mouseDown) {
    return rxjs_1.of(mouseDown).pipe(operators_1.delay(150), operators_1.takeUntil(release));
}; };
var ɵ6 = preventOnDblClick;
exports.ɵ6 = ɵ6;
/**
 * @hidden
 */
var isInSpanColumn = function (column) { return !!(column.parent && column.parent.isSpanColumn); };
var ɵ7 = isInSpanColumn;
exports.ɵ7 = ɵ7;
/**
 * @hidden
 *
 * Calculates the column index. If the column is stated in `SpanColumn`,
 * the index for all child columns equals the index of the first child.
 */
var indexOf = function (target, list) {
    var index = 0;
    var ignore = 0;
    var skip = 0;
    while (index < list.length) {
        var current = list[index];
        var isParentSpanColumn = isInSpanColumn(current);
        if (current === target) {
            break;
        }
        if ((ignore-- <= 0) && isParentSpanColumn) {
            ignore = current.parent.childColumns.length - 1;
            skip += ignore;
        }
        index++;
    }
    return index - skip;
};
var ɵ8 = indexOf;
exports.ɵ8 = ɵ8;
/**
 * @hidden
 */
var ColumnHandleDirective = /** @class */ (function () {
    function ColumnHandleDirective(draggable, element, service, zone, cdr, localization, columnInfoService) {
        this.draggable = draggable;
        this.element = element;
        this.service = service;
        this.zone = zone;
        this.cdr = cdr;
        this.localization = localization;
        this.columnInfoService = columnInfoService;
        this.columns = [];
        this.subscriptions = new rxjs_1.Subscription();
        this.rtl = false;
    }
    Object.defineProperty(ColumnHandleDirective.prototype, "visible", {
        get: function () {
            return this.column.resizable ? 'block' : 'none';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnHandleDirective.prototype, "leftStyle", {
        get: function () {
            return utils_1.isTruthy(this.rtl) ? 0 : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnHandleDirective.prototype, "rightStyle", {
        get: function () {
            return utils_1.isTruthy(this.rtl) ? null : 0;
        },
        enumerable: true,
        configurable: true
    });
    ColumnHandleDirective.prototype.autoFit = function () {
        var _this = this;
        var allLeafs = allLeafColumns(this.columns);
        var currentLeafs = column_common_1.leafColumns([this.column]).filter(function (column) { return utils_1.isTruthy(column.resizable); });
        var columnInfo = currentLeafs.map(function (column) {
            var isParentSpan = isInSpanColumn(column);
            var isLastInSpan = isParentSpan ? column.parent.childColumns.last === column : false;
            var index = indexOf(column, allLeafs);
            return {
                column: column,
                headerIndex: _this.columnsForLevel(column.level).indexOf(column),
                index: index,
                isLastInSpan: isLastInSpan,
                isParentSpan: isParentSpan,
                level: column.level
            };
        });
        currentLeafs.forEach(function (column) { return column.width = 0; });
        this.service.measureColumns(columnInfo);
    };
    ColumnHandleDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (utils_1.isBlank(this.column.width)) {
            this.column.implicitWidth = headerWidth(this.element);
        }
        var service = this.service.changes.pipe(operators_1.filter(function () { return _this.column.resizable; }), operators_1.filter(function (e) { return utils_1.isPresent(e.columns.find(function (column) { return column === _this.column; })); }));
        this.subscriptions.add(service.pipe(operators_1.filter(function (e) { return e.type === 'start'; }))
            .subscribe(this.initState.bind(this)));
        this.subscriptions.add(service.pipe(operators_1.filter(function (e) { return e.type === 'resizeColumn'; }))
            .subscribe(this.resize.bind(this)));
        this.subscriptions.add(this.service.changes.pipe(operators_1.filter(function (e) { return e.type === 'start'; }), operators_1.filter(this.shouldUpdate.bind(this)), operators_1.take(1) //on first resize only
        ).subscribe(this.initColumnWidth.bind(this)));
        this.subscriptions.add(this.zone.runOutsideAngular(function () {
            return _this.draggable.kendoPress.pipe(operators_1.tap(stopPropagation), operators_1.tap(function () { return _this.service.start(_this.column); }), operators_1.switchMap(preventOnDblClick(_this.draggable.kendoRelease)), operators_1.switchMap(createMoveStream(_this.service, _this.draggable)))
                .subscribe(function (_a) {
                var pageX = _a.pageX, originalX = _a.originalX;
                var delta = pageX - originalX;
                var percent = toPercentage(delta, _this.column.resizeStartWidth || _this.column.width);
                _this.service.resizeColumns(percent);
            });
        }));
        this.subscriptions.add(service.pipe(operators_1.filter(function (e) { return e.type === 'autoFitComplete'; }))
            .subscribe(this.sizeToFit.bind(this)));
        this.subscriptions.add(service.pipe(operators_1.filter(function (e) { return e.type === 'triggerAutoFit'; }))
            .subscribe(this.autoFit.bind(this)));
        this.subscriptions.add(this.localization.changes.subscribe(function (_a) {
            var rtl = _a.rtl;
            return _this.rtl = rtl;
        }));
    };
    ColumnHandleDirective.prototype.ngOnDestroy = function () {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    };
    ColumnHandleDirective.prototype.shouldUpdate = function () {
        return !allLeafColumns(this.columns)
            .map(function (column) { return column.width; })
            .some(utils_1.isBlank);
    };
    ColumnHandleDirective.prototype.initColumnWidth = function () {
        this.column.width = headerWidth(this.element);
    };
    ColumnHandleDirective.prototype.initState = function () {
        this.column.resizeStartWidth = headerWidth(this.element);
        this.service.resizedColumn({
            column: this.column,
            oldWidth: this.column.resizeStartWidth
        });
    };
    ColumnHandleDirective.prototype.resize = function (_a) {
        var deltaPercent = _a.deltaPercent;
        var delta = fromPercentage(this.column.resizeStartWidth, deltaPercent);
        if (utils_1.isTruthy(this.rtl)) {
            delta *= -1;
        }
        var newWidth = Math.max(this.column.resizeStartWidth + delta, this.column.minResizableWidth);
        var tableDelta = newWidth > this.column.minResizableWidth ?
            delta : this.column.minResizableWidth - this.column.resizeStartWidth;
        this.updateWidth(this.column, newWidth);
        this.service.resizeTable(this.column, tableDelta);
    };
    ColumnHandleDirective.prototype.sizeToFit = function (_a) {
        var columns = _a.columns, widths = _a.widths;
        var index = columns.indexOf(this.column);
        var width = Math.max.apply(Math, widths.map(function (w) { return w[index]; })) + 1; //add 1px for IE
        var tableDelta = width - this.column.resizeStartWidth;
        this.updateWidth(this.column, width);
        this.service.resizeTable(this.column, tableDelta);
    };
    ColumnHandleDirective.prototype.updateWidth = function (column, width) {
        column.width = width;
        this.columnInfoService.hiddenColumns.forEach(function (col) {
            if (utils_1.isBlank(col.width) && utils_1.isPresent(col.implicitWidth)) {
                // Resize hidden columns to their implicit width so they
                // can be displayed with the same width if made visible.
                col.width = col.implicitWidth;
            }
        });
        this.cdr.markForCheck(); //force CD cycle
    };
    ColumnHandleDirective.prototype.columnsForLevel = function (level) {
        return column_common_1.columnsToRender(this.columns ? this.columns.filter(function (column) { return column.level === level; }) : []);
    };
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Array)
    ], ColumnHandleDirective.prototype, "columns", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", column_base_1.ColumnBase)
    ], ColumnHandleDirective.prototype, "column", void 0);
    tslib_1.__decorate([
        core_1.HostBinding('style.display'),
        tslib_1.__metadata("design:type", String),
        tslib_1.__metadata("design:paramtypes", [])
    ], ColumnHandleDirective.prototype, "visible", null);
    tslib_1.__decorate([
        core_1.HostBinding('style.left'),
        tslib_1.__metadata("design:type", Number),
        tslib_1.__metadata("design:paramtypes", [])
    ], ColumnHandleDirective.prototype, "leftStyle", null);
    tslib_1.__decorate([
        core_1.HostBinding('style.right'),
        tslib_1.__metadata("design:type", Number),
        tslib_1.__metadata("design:paramtypes", [])
    ], ColumnHandleDirective.prototype, "rightStyle", null);
    tslib_1.__decorate([
        core_1.HostListener('dblclick'),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", []),
        tslib_1.__metadata("design:returntype", void 0)
    ], ColumnHandleDirective.prototype, "autoFit", null);
    ColumnHandleDirective = tslib_1.__decorate([
        core_1.Directive({
            selector: '[kendoGridColumnHandle]'
        }),
        tslib_1.__param(0, core_1.Host()),
        tslib_1.__metadata("design:paramtypes", [kendo_angular_common_1.DraggableDirective,
            core_1.ElementRef,
            column_resizing_service_1.ColumnResizingService,
            core_1.NgZone,
            core_1.ChangeDetectorRef,
            kendo_angular_l10n_1.LocalizationService,
            column_info_service_1.ColumnInfoService])
    ], ColumnHandleDirective);
    return ColumnHandleDirective;
}());
exports.ColumnHandleDirective = ColumnHandleDirective;
